document.addEventListener('DOMContentLoaded', function() {

  const isMobile = () => window.innerWidth <= 768;
  const isIPad = () => window.innerWidth > 768 && window.innerWidth <= 1024;
  const isDesktop = () => window.innerWidth > 1366;

  let cache = {
    variantWrapper: null,
    labels: [],
    firstGroup: null,
    secondGroup: null,
    priceBlock: null,
    openPopupBtn: null,
    megadevPopupBtn: null,
    shippingEl: null,
    popupEl: null,
  };
  
  function updateCache() {
    
    cache.variantWrapper = document.querySelector('.product-form__input:nth-of-type(2)');
    cache.labels = cache.variantWrapper ? cache.variantWrapper.querySelectorAll('input[type="radio"] + label') : [];
    cache.firstGroup = document.querySelector('.variant-group-first');
    cache.secondGroup = document.querySelector('.variant-group-second');
    cache.priceBlock = document.querySelector('.product__block--price');
    cache.openPopupBtn = document.querySelector('.open-popup-btn');
    cache.megadevPopupBtn = document.querySelector('.megadev-popup-btn');
    cache.shippingEl = document.querySelector('.product__block--shipping');
    cache.popupEl = document.querySelector('.product__block--popup');
  }
  
  function translateMonths() {
    document.querySelectorAll('.product__block--shipping span').forEach(el => {
        el.textContent = el.textContent
            .replace(/Apr/g, 'Nis')
            .replace(/May/g, 'May')
            .replace(/Jun/g, 'Haz')
            .replace(/Jul/g, 'Tem')
            .replace(/Aug/g, 'Ağu')
            .replace(/Sep/g, 'Eyl')
            .replace(/Oct/g, 'Eki')
            .replace(/Nov/g, 'Kas')
            .replace(/Dec/g, 'Ara')
            .replace(/Jan/g, 'Oca')
            .replace(/Feb/g, 'Şub')
            .replace(/Mar/g, 'Mar');
    });
}
  
  function setupResponsiveStyles() {
    if (!document.getElementById('responsive-styles')) {
      const style = document.createElement('style');
      style.id = 'responsive-styles';
      style.innerHTML = `
        .price-in-ultra-mega {
          transition: all 0.3s ease;
          position: absolute !important;
        }
        .price-in-ultra-mega .price,
        .price-in-ultra-mega .price__regular,
        .price-in-ultra-mega .price__sale,
        .price-in-ultra-mega .price-item {
          transition: font-size 0.3s ease;
        }
        @media (max-width: 1200px) {
          .price-in-ultra-mega {
            max-width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        @media (max-width: 768px) {
          .product-form__input:nth-of-type(1) {
            margin-top: -20px !important; 
          }
          .product-form__input:nth-of-type(1) input[type="radio"] + label {
            margin-bottom: -50px !important; 
          }
          .open-popup-btn, .megadev-popup-btn {
            font-size: 13px !important;
            height: 44px !important;
            min-height: 44px !important;
          }
        }
        @media (min-width: 769px) and (max-width: 1024px) {
          .open-popup-btn,
          .megadev-popup-btn,
          .btn__text {
            font-size: 15px !important;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }

  function organizeVariants() {
    updateCache();
     

  // Bu .product-form bir Quick View içindeyse çalışmasın
  const formEl = cache.variantWrapper?.closest('.product');
  if (formEl && formEl.closest('.modal, [id*="quick"], .quickview, .quick-view')) {
    return;
  }

    
    if (!cache.variantWrapper) return;
    
    const labels = cache.labels;
    if (labels.length === 0) return;
    
    const existingGroups = cache.variantWrapper.querySelectorAll('.variant-group-first, .variant-group-second');
    existingGroups.forEach(group => group.remove());
    
    const firstGroup = document.createElement('div');
    firstGroup.className = 'variant-group-first';
    
    const secondGroup = document.createElement('div');
    secondGroup.className = 'variant-group-second';
    
    const isSecondGroupVisible = localStorage.getItem('variantSecondGroupVisible') === 'true';
    if (isSecondGroupVisible) {
      secondGroup.classList.add('visible');
    }
    
    const sizePrefixes = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
    
    labels.forEach((label, index) => {
      const input = label.previousElementSibling;
      const container = document.createElement('div');
      container.appendChild(input.cloneNode(true));
      const newLabel = label.cloneNode(true);
      
      if (index < sizePrefixes.length && !newLabel.querySelector('.size-prefix')) {
        const originalText = newLabel.innerHTML;
        const formattedText = formatVariantText(originalText);
        
        newLabel.innerHTML = `
          <span class="size-prefix">${sizePrefixes[index]}</span>
          ${formattedText}
        `;
        
        if (index === 1) {
          createBadge(newLabel, 'popular', 'Popüler');
        } else if (index === 3) {
          createBadge(newLabel, 'best', 'En İyi');
        } else if (index > 4) {
          createBadge(newLabel, index === 5 ? 'mega' : 'ultra', index === 5 ? 'Mega' : 'Ultra');
        }
      }
      
      container.appendChild(newLabel);
      
      if (index < 5) {
        firstGroup.appendChild(container);
      } else {
        secondGroup.appendChild(container);
      }
    });
    
    labels.forEach(label => {
      const input = label.previousElementSibling;
      if (input) input.remove();
      label.remove();
    });
    
    cache.variantWrapper.appendChild(firstGroup);
    cache.variantWrapper.appendChild(secondGroup);
    
    updateCache();
    setTimeout(adjustBadgeWidth, 50);
    fixOpenPopupButtonWidth();
    
    if (labels.length <= 5) {
      applyLessThanFiveVariantStyles();
    } else {
      removeLessThanFiveVariantStyles();
    }
  }
  
  function createBadge(label, className, text) {
    const badge = document.createElement('div');
    badge.className = `variant-badge ${className}`;
    badge.textContent = text;
    label.insertBefore(badge, label.firstChild);
    return badge;
  }
  
  function formatVariantText(text) {
    return text.replace(/(\d+)\s?(cm|m|mm)/i, '$1<span class="unit">$2</span>');
  }
  
  function applyLessThanFiveVariantStyles() {
    if (isMobile()) {
      const styleEl = document.getElementById('mobile-variant-fix') || document.createElement('style');
      if (!document.getElementById('mobile-variant-fix')) {
        styleEl.id = 'mobile-variant-fix';
        document.head.appendChild(styleEl);
      }
      
      styleEl.textContent = `
        @media (max-width: 768px) {
          .product-form__input:nth-of-type(2) input[type="radio"] + label {
            width: auto !important;
            display: inline-block !important;
            margin-right: 5px !important;
          }
          .product-form__input:nth-of-type(2) {
            display: flex !important;
            flex-wrap: wrap !important;
          }
        }
      `;
    }
    
    if (cache.priceBlock) {
      cache.priceBlock.style.position = '';
      cache.priceBlock.style.right = '';
      cache.priceBlock.style.top = '';
      cache.priceBlock.style.textAlign = '';
      cache.priceBlock.style.fontSize = '';
      cache.priceBlock.classList.remove('price-in-ultra-mega');
      
      const priceElements = cache.priceBlock.querySelectorAll('.price, .price__regular, .price__sale, .price-item');
      priceElements.forEach(element => {
        element.style.fontSize = '';
      });
    }
  }
  
  function removeLessThanFiveVariantStyles() {
    if (isMobile()) {
      const styleEl = document.getElementById('mobile-variant-fix');
      if (styleEl) {
        styleEl.textContent = '';
      }
    }
  }
  
  function fixOpenPopupButtonWidth() {
    updateCache();
    if (!cache.variantWrapper) return;
    
    const labels = cache.variantWrapper.querySelectorAll('input[type="radio"] + label');
    
    if (labels.length <= 5 && isMobile()) {
      if (cache.openPopupBtn) {
        cache.openPopupBtn.setAttribute('style', 'width: 100% !important; max-width: 100% !important; box-sizing: border-box !important; margin: 10px 0 !important; display: block !important;');
      }
      
      if (cache.megadevPopupBtn) {
        cache.megadevPopupBtn.style.display = 'none';
      }
      
      let styleEl = document.getElementById('popup-btn-override-extreme');
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = 'popup-btn-override-extreme';
        document.head.appendChild(styleEl);
      }
      
      styleEl.innerHTML = `
        @media (max-width: 768px) {
          .open-popup-btn[style*="width"],
          .open-popup-btn {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 100% !important;
            display: block !important;
            margin: 10px 0 !important;
            box-sizing: border-box !important;
          }
          .megadev-popup-btn {
            display: none !important;
          }
        }
      `;
    } else {
      if (cache.openPopupBtn) {
        cache.openPopupBtn.removeAttribute('style');
      }
      
      if (cache.megadevPopupBtn) {
        cache.megadevPopupBtn.style.display = '';
      }
      
      const styleEl = document.getElementById('popup-btn-override-extreme');
      if (styleEl) {
        styleEl.innerHTML = '';
      }
    }
    
    if (isIPad()) {
      if (cache.openPopupBtn) {
        cache.openPopupBtn.style.fontSize = '15px';
      }
      
      if (cache.megadevPopupBtn) {
        cache.megadevPopupBtn.style.fontSize = '15px';
      }
      
      document.querySelectorAll('.btn__text').forEach(el => {
        el.style.fontSize = '15px';
      });
    }
  }
  
  function adjustBadgeWidth() {
    const variantLabels = document.querySelectorAll('.product-form__input:nth-of-type(2) label');
    if (variantLabels.length > 0) {
      const variantWidth = variantLabels[0].offsetWidth;
      
      document.querySelectorAll('.variant-badge').forEach(badge => {
        badge.style.width = `${variantWidth}px`;
        badge.style.left = '0';
        badge.style.right = '0';
        badge.style.bottom = '100%';
        badge.style.marginBottom = '-8px';
        badge.style.top = 'auto';
      });
    }
  }
  
  let lastClickedLabel = null;
  function handleVariantClick(e) {
    const label = e.target.closest('.product-form__input:nth-of-type(2) label');
    if (!label) return;
    
    const radioInput = label.previousElementSibling;
    if (!radioInput || radioInput.checked) return;
    
    if (lastClickedLabel === label) return;
    
    e.preventDefault();
    e.stopPropagation();
    lastClickedLabel = label;
    
    const labels = document.querySelectorAll('.product-form__input:nth-of-type(2) label');
    labels.forEach(l => l.classList.remove('animate-scale'));
    label.classList.add('animate-scale');
    
    setTimeout(() => {
      radioInput.checked = true;
      radioInput.dispatchEvent(new Event('change', { bubbles: true }));
      lastClickedLabel = null;
      
      checkSelectedVariant();
      
      setTimeout(togglePricePosition, 50);
    }, 300);
  }
  
  function checkSelectedVariant() {
    updateCache();
    if (!cache.variantWrapper || !cache.secondGroup || !cache.megadevPopupBtn) return;
    
    const allVariants = cache.variantWrapper.querySelectorAll('input[type="radio"]');
    let selectedIndex = -1;
    
    allVariants.forEach((input, index) => {
      if (input.checked) {
        selectedIndex = index;
      }
    });
    
    if (selectedIndex >= 5) {
      cache.secondGroup.classList.add('visible');
      cache.megadevPopupBtn.classList.add('active');
      localStorage.setItem('variantSecondGroupVisible', 'true');
      cache.megadevPopupBtn.style.backgroundColor = '#ff0000';
    } else {
      cache.secondGroup.classList.remove('visible');
      cache.megadevPopupBtn.classList.remove('active');
      localStorage.setItem('variantSecondGroupVisible', 'false');
      cache.megadevPopupBtn.style.backgroundColor = '#FF8000';
      togglePricePosition(); 
    }
  }
  
  function createMegadevButton() {
  const customLiquidBlocks = document.querySelectorAll('.product__block.product__block--custom_liquid');
  let targetBlock = null;
  
  // Hedef bloğu bul
  customLiquidBlocks.forEach(block => {
    if (block.querySelector('.open-popup-btn')) {
      targetBlock = block;
    }
  });
  
  if (!targetBlock) return;
  if (targetBlock.querySelector('.megadev-popup-btn')) return;
  
  // Hemen butonları ve container'ı ayarla
  const openPopupBtn = targetBlock.querySelector('.open-popup-btn');
  const buttonContainer = openPopupBtn.parentNode;
  
  // Buton zaten var ama gizliyse, işlemi atla
  if (buttonContainer.getAttribute('data-megadev-initialized') === 'true') {
    return;
  }
  
  // Butonları oluşturmadan önce container'ı ayarla
  buttonContainer.style.display = 'flex';
  buttonContainer.style.alignItems = 'center';
  buttonContainer.style.gap = '10px';
  buttonContainer.setAttribute('data-megadev-initialized', 'true');

    
  // Yeni butonu oluştur
  const megadevButton = document.createElement('button');
  megadevButton.className = 'megadev-popup-btn';
  megadevButton.textContent = 'Ultra Mega Ölçüler';

  megadevButton.disabled = true;

  const openpopupdisabled = targetBlock.querySelector('.open-popup-btn');
  openpopupdisabled.disabled = true;
    
  // Butonu ekle
  buttonContainer.insertBefore(megadevButton, openPopupBtn);
  
  // İkinci grup görünürlüğünü ayarla
  const isSecondGroupVisible = localStorage.getItem('variantSecondGroupVisible') === 'true';
  if (isSecondGroupVisible) {
    megadevButton.classList.add('active');
    
    const secondGroup = document.querySelector('.variant-group-second');
    if (secondGroup) {
      secondGroup.classList.add('visible');
    }
  }

      setTimeout(() => {
    megadevButton.disabled = false;
    openpopupdisabled.disabled = false;

        
  // Tıklama olayını ekle
  megadevButton.addEventListener('click', function() {
    const secondGroup = document.querySelector('.variant-group-second');
    if (!secondGroup) return;
    
    const isVisible = secondGroup.classList.contains('visible');
    
    if (isVisible) {
      secondGroup.classList.remove('visible');
      this.classList.remove('active');
      localStorage.setItem('variantSecondGroupVisible', 'false');
      this.style.backgroundColor = '#FF8000';
    } else {
      secondGroup.classList.add('visible');
      this.classList.add('active');
      localStorage.setItem('variantSecondGroupVisible', 'true');
      this.style.backgroundColor = '#ff0000';
    }
    
    // Fiyat pozisyonunu güncelle
    setTimeout(togglePricePosition, 50);
    setTimeout(togglePricePosition, 200);
  });
   }, 2000); 
  }
  
  function togglePricePosition() {
    
    
  updateCache();
  if (!cache.priceBlock) return;

  const innerSel = '.price, .price__container, .price__regular, .price__sale, .price-item, .f-price, .f-price__container, .f-price-item--regular, .f-price-item--sale';
  const taxText = document.querySelector('.product__tax.text-sm.text-subtext.rte');
const setMobileRight = () => {
  // Ana price block için inline style ile zorla
  cache.priceBlock.setAttribute('style', cache.priceBlock.getAttribute('style') + '; text-align: right !important; direction: rtl !important;');
  
  cache.priceBlock.querySelectorAll(innerSel).forEach(el => {
    if (getComputedStyle(el).display.includes('flex')) {
      el.style.setProperty('justify-content', 'flex-end', 'important');
      el.style.setProperty('direction', 'rtl', 'important');
    }
    el.style.setProperty('text-align', 'right', 'important');
    el.style.setProperty('margin-left', 'auto', 'important');
    el.style.setProperty('direction', 'rtl', 'important');
  });
  
  
  // Tax text için özel düzenleme - RTL'yi override et
  const taxText = document.querySelector('.product__tax.text-sm.text-subtext.rte');
  if (taxText) {
    taxText.style.setProperty('direction', 'ltr', 'important');
    taxText.style.setProperty('text-align', 'right', 'important');
    taxText.style.setProperty('display', 'inline-block', 'important');
  }
};

const clearAlign = () => {
  cache.priceBlock.style.removeProperty('text-align');
  cache.priceBlock.style.removeProperty('direction');
  
  cache.priceBlock.querySelectorAll(innerSel).forEach(el => {
    el.style.removeProperty('justify-content');
    el.style.removeProperty('text-align');
    el.style.removeProperty('margin-left');
    el.style.removeProperty('direction');
  });
  
  // Tax text'i temizle
  const taxText = document.querySelector('.product__tax.text-sm.text-subtext.rte');
  if (taxText) {
    taxText.style.removeProperty('direction');
    taxText.style.removeProperty('text-align');
    taxText.style.removeProperty('display');
  }
};

  if (cache.variantWrapper && cache.labels.length <= 5) {
    cache.priceBlock.style.position = '';
    cache.priceBlock.style.right = '';
    cache.priceBlock.style.top = '';
    cache.priceBlock.style.fontSize = '';
    cache.priceBlock.classList.remove('price-in-ultra-mega');
    clearAlign();
    cache.priceBlock.querySelectorAll('.price, .price__regular, .price__sale, .price-item').forEach(el => el.style.fontSize = '');
    return;
  }

  if (!cache.secondGroup) return;

  if (cache.secondGroup.classList.contains('visible')) {
    if (!cache.priceBlock.dataset.originalStyles) {
      cache.priceBlock.dataset.originalStyles = JSON.stringify({
        position: cache.priceBlock.style.position,
        right: cache.priceBlock.style.right,
        top: cache.priceBlock.style.top,
        textAlign: cache.priceBlock.style.textAlign,
        fontSize: cache.priceBlock.style.fontSize
      });
    }

    cache.priceBlock.style.position = 'absolute';
    cache.priceBlock.style.right = '0';

    const s = cache.priceBlock.querySelector('.f-price-item--regular s');
    const isSale = !!(s && s.textContent.trim() !== '' && s.offsetParent !== null);

    let topPosition;
    if (isMobile()) {
      topPosition = cache.secondGroup.offsetTop + 35;
    } else {
      const h = cache.secondGroup.offsetHeight;
      topPosition = cache.secondGroup.offsetTop + h - 50;
    }
    if (isSale) topPosition -= 20;
    if (isMobile()) topPosition -= 10;
    cache.priceBlock.style.top = topPosition + 'px';

    if (isMobile()) {
      setMobileRight();
      cache.priceBlock.style.transform = "translateX(-10px) translateY(-5px)";

    } else {
      clearAlign();
      cache.priceBlock.style.transform = "";
    }


    cache.priceBlock.classList.add('price-in-ultra-mega');

    // Vergi/Kargo yazısını tek satır, sağa hizalı ve taşmadan göster
  if (taxText) {
  if (!taxText.dataset.orig) {
    const cs = getComputedStyle(taxText);
    taxText.dataset.orig = JSON.stringify({ fontSize: cs.fontSize });
  }
  taxText.querySelectorAll('br').forEach(b => b.remove());
  taxText.style.whiteSpace = 'nowrap';
  taxText.style.display = 'block';
  taxText.style.width = '100%';
  taxText.style.textAlign = 'right';
  taxText.style.overflow = 'hidden';
  taxText.style.textOverflow = 'clip';
    taxText.style.fontSize = '14px'; 
taxText.style.marginTop = '-5px';      // fiyat ile arayı sıfırla
  // Taşmadan tek satıra sığdır (dinamik font küçültme)
  const orig = JSON.parse(taxText.dataset.orig || '{}');
  let f = parseFloat(orig.fontSize) || parseFloat(getComputedStyle(taxText).fontSize) || 14;
  taxText.style.fontSize = f + 'px';
  for (let i = 0; i < 40 && taxText.scrollWidth > taxText.clientWidth; i++) {
    f -= 0.5;
    taxText.style.fontSize = f + 'px';
  }
}

    handlePriceResize();
  } else {
    if (cache.priceBlock.dataset.originalStyles) {
      const o = JSON.parse(cache.priceBlock.dataset.originalStyles);
      cache.priceBlock.style.position = o.position || '';
      cache.priceBlock.style.right = o.right || '';
      cache.priceBlock.style.top = o.top || '';
      cache.priceBlock.style.textAlign = o.textAlign || '';
      cache.priceBlock.style.fontSize = o.fontSize || '';
    } else {
      cache.priceBlock.style.position = '';
      cache.priceBlock.style.right = '';
      cache.priceBlock.style.top = '';
      cache.priceBlock.style.textAlign = '';
      cache.priceBlock.style.fontSize = '';
    }
    cache.priceBlock.classList.remove('price-in-ultra-mega');
        cache.priceBlock.style.transform = "";
    // Varsayılan hâle döndür
if (taxText && taxText.dataset.orig) {
  const o = JSON.parse(taxText.dataset.orig);
  taxText.style.fontSize = o.fontSize || '';
  taxText.style.whiteSpace = '';
  taxText.style.display = '';
  taxText.style.width = '';
  taxText.style.textAlign = '';
  taxText.style.overflow = '';
  taxText.style.textOverflow = '';
  taxText.style.marginTop = '';
}
    clearAlign();
  }
}
  
  function handlePriceResize() {
    updateCache();
    if (!cache.priceBlock) return;
    
    if (cache.labels.length <= 5) {
      if (cache.priceBlock.dataset.originalStyles) {
        const originalStyles = JSON.parse(cache.priceBlock.dataset.originalStyles);
        cache.priceBlock.style.fontSize = originalStyles.fontSize || '';
      } else {
        cache.priceBlock.style.fontSize = '';
      }
      
      const priceElements = cache.priceBlock.querySelectorAll('.price, .price__regular, .price__sale, .price-item');
      priceElements.forEach(element => {
        element.style.fontSize = '';
      });
      
      return;
    }
    
    if (!cache.secondGroup || !cache.secondGroup.classList.contains('visible')) {
      if (cache.priceBlock.dataset.originalStyles) {
        const originalStyles = JSON.parse(cache.priceBlock.dataset.originalStyles);
        cache.priceBlock.style.fontSize = originalStyles.fontSize || '';
      }
      return;
    }
    
    const windowWidth = window.innerWidth;
    const baseWidth = 1366;
    
    if (windowWidth < baseWidth) {
      const ratio = Math.max(0.65, windowWidth / baseWidth);
      
      cache.priceBlock.style.fontSize = `${ratio}em`;
      
      const priceElements = cache.priceBlock.querySelectorAll('.price, .price__regular, .price__sale, .price-item');
      priceElements.forEach(element => {
        element.style.fontSize = `${ratio}em`;
      });
    } else {
      cache.priceBlock.style.fontSize = '';
      
      const priceElements = cache.priceBlock.querySelectorAll('.price, .price__regular, .price__sale, .price-item');
      priceElements.forEach(element => {
        element.style.fontSize = '';
      });
    }
  }
  
  function equalizeButtonUnderlines() {
    const sizeChartBtn = document.querySelector('.open-size-chart.no-js-hidden.btn--link.tracking-normal');
    const popupBtnText = document.querySelector('.product__block--popup .btn__text');
    
    if (sizeChartBtn && popupBtnText && window.innerWidth > 768) {
      sizeChartBtn.style.textDecoration = 'none';
      popupBtnText.style.textDecoration = 'none';
      
      if (sizeChartBtn.parentElement) sizeChartBtn.parentElement.style.textDecoration = 'none';
      if (popupBtnText.parentElement) popupBtnText.parentElement.style.textDecoration = 'none';
      if (popupBtnText.parentElement && popupBtnText.parentElement.parentElement) {
        popupBtnText.parentElement.parentElement.style.textDecoration = 'none';
      }
      
      sizeChartBtn.style.display = 'inline-block';
      popupBtnText.style.display = 'inline-block';
    }
  }
  
  function fixIOSSpecificIssues() {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    if (isIOS) {
      updateCache();
      
      if (cache.megadevPopupBtn && cache.openPopupBtn) {
        const maxHeight = Math.max(cache.megadevPopupBtn.offsetHeight, cache.openPopupBtn.offsetHeight);
        cache.megadevPopupBtn.style.height = maxHeight + 'px';
        cache.openPopupBtn.style.height = maxHeight + 'px';
      }
      
      const sizeChart = document.querySelector('.open-size-chart');
      if (sizeChart) {
        sizeChart.style.float = 'right';
        sizeChart.style.position = 'relative';
        sizeChart.style.top = '-5px';
      }
      
      if (cache.popupEl) {
        const computedStyle = window.getComputedStyle(cache.popupEl);
        const originalPosition = computedStyle.position;
        const originalTop = computedStyle.top;
        
        cache.popupEl.style.position = originalPosition;
        cache.popupEl.style.top = originalTop;
        cache.popupEl.style.right = 'auto';
        cache.popupEl.style.left = '0';
        cache.popupEl.style.textAlign = 'left';
      }
      
      const variantLabels = document.querySelectorAll('.product-form__input:nth-of-type(2) input[type="radio"] + label');
      variantLabels.forEach(label => {
        label.style.marginTop = '15px';
      });
      
      if (!document.getElementById('ios-fixes')) {
        const styleEl = document.createElement('style');
        styleEl.id = 'ios-fixes';
        styleEl.innerHTML = `
          .megadev-popup-btn, .open-popup-btn {
            display: flex !important;
            align-items: center !important;
          }
          
          .open-size-chart {
            float: right !important;
            position: relative !important;
            top: -5px !important;
          }
          
          .product__block--popup {
            right: auto !important;
            left: 0 !important;
            text-align: left !important;
          }
          
          .product-form__input:nth-of-type(2) input[type="radio"] + label {
            margin-top: 0px !important;
          }
        `;
        document.head.appendChild(styleEl);
      }
    }
  }
  
  function toggleDividers() {
    const buyButtons = document.querySelector('.product__block.product__block--buy_buttons');
    if (!buyButtons) return;
    
    const blocks = document.querySelectorAll('.product__block');
    let firstDividerAfterBuyButtons = null;
    let secondDividerAfterBuyButtons = null;
    let foundBuyButtons = false;
    
    blocks.forEach(block => {
      if (foundBuyButtons && block.classList.contains('product__block--divider')) {
        if (!firstDividerAfterBuyButtons) {
          firstDividerAfterBuyButtons = block;
        } else if (!secondDividerAfterBuyButtons) {
          secondDividerAfterBuyButtons = block;
        }
      }
      
      if (block === buyButtons) {
        foundBuyButtons = true;
      }
    });
    
    if (window.innerWidth > 1367) {
      if (firstDividerAfterBuyButtons) {
        firstDividerAfterBuyButtons.style.display = 'none';
      }
      if (secondDividerAfterBuyButtons) {
        secondDividerAfterBuyButtons.style.display = 'none';
      }
    } else {
      if (firstDividerAfterBuyButtons) {
        firstDividerAfterBuyButtons.style.display = '';
      }
      if (secondDividerAfterBuyButtons) {
        secondDividerAfterBuyButtons.style.display = '';
      }
    }
  }
  
  function formatShippingText() {
    if (cache.shippingEl && cache.shippingEl.textContent.includes(':')) {
      const [label, detail] = cache.shippingEl.textContent.split(':');
      cache.shippingEl.innerHTML = `${label}:<br><span class="shipping-detail">${detail.trim()}</span>`;
    }
  }
  
  function setupDesktopLayout() {
    if (!isDesktop()) return;
    
    updateCache();
    if (!cache.shippingEl || !cache.popupEl) return;
    
    const container = document.querySelector('.product-form__input:nth-of-type(1)');
    if (!container) return;
    
    container.style.position = 'relative';
    
    cache.shippingEl.style.cssText = `
      position: absolute !important;
      top: 0 !important;
      right: 0 !important;
      margin: 0 !important;
      z-index: 1 !important;
    `;
    
    cache.popupEl.style.cssText = `
      position: absolute !important;
      top: 65px !important;
      right: 0 !important;
      margin: 0 !important;
      z-index: 1 !important;
    `;
  }

  function disableDesktopLayout() {
    updateCache();
    if (!cache.shippingEl || !cache.popupEl) return;
    
    const container = document.querySelector('.product-form__input:nth-of-type(1)');
    if (!container) return;
    
    container.style.position = '';
    cache.shippingEl.style.cssText = '';
    cache.popupEl.style.cssText = '';
    
    remove1367CSSAndShippingBreak();
    disableShippingSplit();
  }
  
  function remove1367CSSAndShippingBreak() {
    if (document.getElementById('disable-1367-style')) return;
    
    const style = document.createElement('style');
    style.id = 'disable-1367-style';
    style.innerHTML = `
      @media (max-width: 1367px) {
        .product__block--popup,
        .open-size-chart.no-js-hidden.btn--link.tracking-normal,
        .product__block--shipping,
        .product__block--popup .btn__text {
          font-size: initial !important;
        }
      }
    `;
    document.head.appendChild(style);
  }
  
  function disableShippingSplit() {
    updateCache();
    if (!cache.shippingEl) return;
    
    const combinedText = cache.shippingEl.textContent
      .replace(/\s+/g, ' ')
      .replace(/\s*:\s*/, ': ')
      .trim();
    
    cache.shippingEl.innerHTML = combinedText;
  }
  
  function setupMobileButtonAnimations() {
    if (!isMobile()) return;
    
    const buttons = document.querySelectorAll('.open-popup-btn, .megadev-popup-btn');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.hasAttribute('data-animated')) {
            entry.target.classList.add('animate-mobile');
            entry.target.setAttribute('data-animated', 'true');
            setTimeout(() => {
              entry.target.classList.remove('animate-mobile');
            }, 3000);
            observer.unobserve(entry.target);
          }
        });
      });
      buttons.forEach(button => observer.observe(button));
    }
  }
  
  function setupObservers() {
    // DOM değişikliklerini izle
    const observer = new MutationObserver((mutations) => {
      let needsUpdate = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          needsUpdate = true;
        }
      });
      
    if (needsUpdate) {
  organizeVariants();
  checkSelectedVariant();
}


    });
    //d gsd gsdg sdg dsv v sv v sdv dsv sdvsd
    const targetNode = document.querySelector('.product-form') || document.body;
    observer.observe(targetNode, { childList: true, subtree: true });
    
    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(debounce(() => {
        adjustBadgeWidth();
        handlePriceResize();
        togglePricePosition();
        fixOpenPopupButtonWidth();
        equalizeButtonUnderlines();
        toggleDividers();
        
        if (isDesktop()) {
          setupDesktopLayout();
        } else {
          disableDesktopLayout();
        }
      }, 100));
      
      resizeObserver.observe(document.body);
    }
  }
  
  function setupPeriodicChecks() {
    let checkCount = 0;
    const maxChecks = 5; // 20'den 5'e düşürüldü
    const checkInterval = 500;
    
    function performCheck() {
      togglePricePosition();
      handlePriceResize();
      checkSelectedVariant();
      
      checkCount++;
      if (checkCount < maxChecks) {
        setTimeout(performCheck, checkInterval);
      }
    }
    
    performCheck();
  }
  
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
  
  function setupVariantChangeListeners() {
    document.addEventListener('click', debounce(handleVariantClick, 50), true);
    
    document.addEventListener('change', debounce(function(e) {
      if (e.target.type === 'radio' && e.target.closest('.product-form__input:nth-of-type(2)')) {
        checkSelectedVariant();
        setTimeout(togglePricePosition, 0);
        setTimeout(togglePricePosition, 200);
      }
    }, 50));
  }
  
  function initialize() {
    translateMonths();
    setupResponsiveStyles();
    updateCache();
    
    organizeVariants();
    checkSelectedVariant();
    formatShippingText();
    
    if (isDesktop()) {
      setupDesktopLayout();
    } else {
      disableDesktopLayout();
    }
    
    adjustBadgeWidth();
    fixOpenPopupButtonWidth();
    equalizeButtonUnderlines();
    toggleDividers();
    
  if (cache.labels.length > 5) {
    createMegadevButton();
  }    
    fixIOSSpecificIssues();
    
    setupMobileButtonAnimations();
    
    setupObservers();
    setupVariantChangeListeners();
    
    setupPeriodicChecks();
  }
  
  initialize();
  
  window.addEventListener('resize', debounce(() => {
    adjustBadgeWidth();
    fixOpenPopupButtonWidth();
    equalizeButtonUnderlines();
    toggleDividers();
    togglePricePosition();
    handlePriceResize();
    
    if (isDesktop()) {
      setupDesktopLayout();
    } else {
      disableDesktopLayout();
    }
    
    fixIOSSpecificIssues();
  }, 200));
});